export const getRegion = (regionID) => ({ regions }) =>
  regions.regionsList.find(({ id }) => id === regionID);
